<template>
    <v-card>
        <v-form ref="statusForm" v-model="validStatusForm" @submit.prevent="changeOfertaStatus">
            <v-card-title>
                <span class="text-h5">Schimba status oferta</span>
            </v-card-title>
            <v-card-text>
                <v-radio-group v-model="changedStatusItem.status_oferta" row>
                    <v-radio label="Oferta noua" color="teal" class="mb-2" value="noua"></v-radio>
                    <v-radio label="Client contactat" color="teal" class="mb-2" value="contactat"></v-radio>
                    <v-radio label="In asteptare" color="teal" class="mb-2" value="in asteptare"></v-radio>
                    <v-radio label="Oferta acceptata" color="teal" class="mb-2" value="acceptata"></v-radio>
                    <v-radio label="Clientul nu cumpara" color="teal" class="mb-2" value="nu e acceptata"></v-radio>
                </v-radio-group>
                <div v-if="changedStatusItem.status_oferta == 'contactat'">
                    <h3>Cum a fost contactat clientul?</h3>
                    <div class="flex gap-8">
                        <v-radio-group class="flex-grow" v-model="changedStatusItem.contactType" row
                            :rules="[rules.required]">
                            <v-radio label="Prin telefon" color="teal" value="telefon"></v-radio>
                            <v-radio label="Prin email" color="teal" value="email"></v-radio>
                        </v-radio-group>
                        <v-menu v-model="contactDatepickerMenu" :close-on-content-click="false"
                            transition="scale-transition" :nudge-right="40" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field class="flex-grow-0" v-model="computedDateFormatted" label="La data de"
                                    prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined
                                    :rules="[rules.required]"></v-text-field>
                            </template>
                            <v-date-picker v-model="changedStatusItem.contactDate" no-title
                                @input="contactDatepickerMenu = false"></v-date-picker>
                        </v-menu>
                    </div>
                </div>
                <div v-if="changedStatusItem.status_oferta == 'in asteptare'">
                    <h3>Motiv</h3>
                    <v-radio-group v-model="changedStatusItem.pending_reason" row :rules="[rules.required]">
                        <v-radio v-for="item in pendingReasons" :key="item.value" :label="item.text" color="teal"
                            class="mb-2" :value="item.value">
                        </v-radio>
                    </v-radio-group>
                </div>
                <div v-if="changedStatusItem.status_oferta == 'nu e acceptata'">
                    <h3>De ce nu a comandat de la noi?</h3>
                    <v-radio-group v-model="changedStatusItem.reject_reason" row :rules="[rules.required]">
                        <v-radio v-for="item in rejectMotives" :key="item.value" :label="item.text" color="teal"
                            class="mb-2" :value="item.value">
                        </v-radio>
                    </v-radio-group>
                    <div v-if="changedStatusItem.reject_reason == 'lucreaza numai cu termen de plata'">
                        <v-btn text color="blue" :disabled="sentAnalysis" class="white-text uppercase mt-2"
                            @click="$emit('requestAnalysis')">
                            <span v-if="sentAnalysis">
                                Solicitare analiză trimisă
                            </span>
                            <span v-else>
                                Solicita analiza clientului
                            </span>
                            <v-icon v-if="!sentAnalysis" right>
                                mdi-arrow-right-thin
                            </v-icon>
                        </v-btn>
                    </div>
                </div>
            </v-card-text>
            <div class="flex flex-row justify-end gap-2 mt-4 p-4">
                <v-btn color="blue-grey" class="uppercase" dark large @click="closeModal">Anuleaza</v-btn>
                <v-btn color="teal" dark class="uppercase" large type="submit">Salveaza</v-btn>
            </div>
        </v-form>
    </v-card>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "OfertaStatusCard",
    props: {
        changedStatusItem: {
            type: Object,
            required: true
        },
        sentAnalysis: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            validStatusForm: false,
            contactDatepickerMenu: false,
            rules: {
                required: value => !!value || 'Câmp obligatoriu'
            }
        }
    },
    computed: {
        ...mapState('salesLeads', ['pendingReasons', 'rejectMotives']),
        computedDateFormatted() {
            return this.$options.filters.formatDate(this.changedStatusItem.contactDate)
        }
    },
    methods: {
        async changeOfertaStatus() {
            const valid = await this.$refs.statusForm.validate();

            if (valid) {
                this.$store.dispatch("updOfertaStatus", this.changedStatusItem);
                this.closeModal()
            }

        },
        closeModal() {
            this.$emit('close');
        },
    }
}
</script>